<template>
  <CardModule title="Dados Cadastrais">
    <v-row>
      <v-col cols="12" sm="6">
        <v-radio-group
          v-model="$pointOfSale.cadastro.dados_cadastrais.pessoa"
          class="mt-0"
          hide-details
        >
          <template v-slot:label>
            <span>Tipo de Pessoa:</span>
          </template>
          <v-radio
            value="JURIDICA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Jurídica<br />
                <small></small>
              </div>
            </template>
          </v-radio>
          <v-radio
            value="FISICA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                Física<br />
                <small></small>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row v-show="typePersonPJ">
      <v-col cols="12" sm="6">
        <BaseTextField
          label="Razão Social"
          placeholder="Insira a Razão Social"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.razao_social"
          :error-messages="
            $pointOfSale.cadastro.dados_cadastrais.error.razao_social
          "
          @input="
            $pointOfSale.cadastro.dados_cadastrais.error.razao_social = []
          "
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseTextField
          label="CNPJ"
          placeholder="Insira o CNPJ"
          hide-details
          v-mask="'##.###.###/####-##'"
          v-model="$pointOfSale.cadastro.dados_cadastrais.cnpj"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.cnpj"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.cnpj = []"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseTextField
          hide-details
          :placeholder="
            typePersonPJ
              ? 'Insira o nome do representante'
              : 'Insira o nome do responsável'
          "
          v-model="$pointOfSale.cadastro.dados_cadastrais.nome_representante"
          :error-messages="
            $pointOfSale.cadastro.dados_cadastrais.error.nome_representante
          "
          @input="
            $pointOfSale.cadastro.dados_cadastrais.error.nome_representante = []
          "
        >
          <template v-slot:label>
            <span class="red--text">*</span>
            <span v-if="typePersonPJ">Nome do Representante</span>
            <span v-if="!typePersonPJ">Nome do Responsável</span>
          </template>
        </BaseTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          label="CPF"
          placeholder="Insira o CPF"
          hide-details
          v-mask="'###.###.###-##'"
          v-model="$pointOfSale.cadastro.dados_cadastrais.cpf"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.cpf"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.cpf = []"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          label="RG"
          placeholder="Insira o RG"
          hide-details
          v-mask="'##.###.###-##'"
          v-model="$pointOfSale.cadastro.dados_cadastrais.rg"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.rg"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.rg = []"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          label="Órgão expedidor"
          placeholder="Insira o orgão expedidor"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.rg_orgao"
          :error-messages="
            $pointOfSale.cadastro.dados_cadastrais.error.rg_orgao
          "
          @input="$pointOfSale.cadastro.dados_cadastrais.error.rg_orgao = []"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          placeholder="Insira seu e-mail"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.email"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.email"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.email = []"
        >
          <template v-slot:label>
            <span class="red--text">*</span>
            E-mail
          </template>
        </BaseTextField>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          label="Celular"
          placeholder="Insira o celular"
          hide-details
          v-mask="['(##) ####-####', '(##) #####-####']"
          v-model="$pointOfSale.cadastro.dados_cadastrais.celular"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.celular"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.celular = []"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseSelect
          :items="$loja_gerenciar.regionais"
          item-text="nome"
          item-value="idregional"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.regional"
          :error-messages="
            $pointOfSale.cadastro.dados_cadastrais.error.regional
          "
          @input="$pointOfSale.cadastro.dados_cadastrais.error.regional = []"
        >
          <template v-slot:label>
            <span class="red--text">*</span>
            Regional
          </template>
        </BaseSelect>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseSelect
          label="Status"
          :items="$pointOfSale.status_pdv"
          item-text="value"
          item-value="key"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.status"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.status"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.status = []"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseSelect
          :items="$tipos_pdv.tipos_pdv"
          item-text="descricao"
          item-value="idtipo_pdv"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.tipo_ponto_venda"
          :error-messages="
            $pointOfSale.cadastro.dados_cadastrais.error.tipo_ponto_venda
          "
          @input="
            $pointOfSale.cadastro.dados_cadastrais.error.tipo_ponto_venda = []
          "
        >
          <template v-slot:label>
            <span class="red--text">*</span>
            Tipo de ponto de venda
          </template>
        </BaseSelect>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          label="CEP"
          placeholder="Insira o CEP"
          hide-details
          v-mask="'#####-###'"
          v-model="$pointOfSale.cadastro.dados_cadastrais.cep"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.cep"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.cep = []"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseAutocomplete
          label="Estado"
          :items="$config.estados.result"
          v-model="estado"
          item-text="dsc_lang"
          return-object
          hide-details
          :filter="search"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.estado"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.estado = []"
        >
          <template v-slot:selection="{ item }">
            <div v-if="item ? (estados = item) : null">
              {{ item.dsc_lang }}
            </div>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseAutocomplete
          label="Cidade"
          placeholder="Selecione a cidade"
          :items="$config.cidades.result"
          v-model="$pointOfSale.cadastro.dados_cadastrais.cidade"
          item-text="dsc_lang"
          item-value="iso_full"
          hide-details
          :filter="search"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.cidade"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.cidade = []"
        >
          <template v-slot:selection="{ item }">
            <div v-if="item ? (cidades = item) : null">
              {{ item.dsc_lang }}
            </div>
          </template>
        </BaseAutocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseTextField
          label="Bairro"
          placeholder="Insira o bairro"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.bairro"
          :error-messages="$pointOfSale.cadastro.dados_cadastrais.error.bairro"
          @input="$pointOfSale.cadastro.dados_cadastrais.error.bairro = []"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseTextField
          label="Endereço"
          placeholder="Insira o endereço"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.logradouro"
          :error-messages="
            $pointOfSale.cadastro.dados_cadastrais.error.logradouro
          "
          @input="$pointOfSale.cadastro.dados_cadastrais.error.logradouro = []"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <BaseTextField
          label="Complemento"
          placeholder="Insira o complemento"
          hide-details
          v-model="$pointOfSale.cadastro.dados_cadastrais.complemento"
          :error-messages="
            $pointOfSale.cadastro.dados_cadastrais.error.complemento
          "
          @input="$pointOfSale.cadastro.dados_cadastrais.error.complemento = []"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import PDVmixins from "@/mixins/PDV.mixins.js";
export default {
  name: "RegistrationData",
  mixins: [PDVmixins],
  components: {
    CardModule,
    BaseTextField,
    BaseSelect,
    BaseAutocomplete,
  },
  data() {
    return {
      paises: [],
      estado: null,
      cidades: [],
    };
  },
  computed: {
    typePersonPJ() {
      return this.$pointOfSale.cadastro.dados_cadastrais.pessoa === "JURIDICA";
    },
  },
  methods: {
    replaceSpecialChars(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[èèêë]/, "e");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str
        .toString()
        .normalize("NFD")
        .replace(/[^a-zA-Zs]/g, "");
      str = str.replace(" ", "-");

      return str;
      // return str.replace(/[^a-z0-9]/gi,'-');
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.dsc_lang.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  watch: {
    paises(e) {
      this.$config.getEstados(e.id);
    },
    estado(state) {
      const { iso_full, id } = state;
      this.$pointOfSale.cadastro.dados_cadastrais.estado = iso_full;
      this.$config.getCidades(id);
    },
  },
  mounted() {
    this.$config.getPaises();
  },
};
</script>
<style scoped>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
.ponto-de-venda-container05 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.ponto-de-venda-container06 {
  flex: 0 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: column;
  justify-content: center;
}
</style>
